<template>
  <div class="checkbox-inline" :data-test-base-single-checkbox="name">
    <input
      :id="name"
      :checked="modelValue"
      :disabled="disabled"
      :name="name"
      type="checkbox"
      :class="{ invalid: hasErrors }"
      :data-test-base-single-checkbox-input="dataTestInput"
      @change="handleChange"
    />
    <label :for="name" :class="{ large: large }" v-html="label" />
  </div>
</template>

<script>
export default {
  name: 'BaseSingleCheckbox',
  // inject: ['$validator'],
  props: {
    dataTestInput: {
      type: String,
      default() {
        return '';
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    label: {
      type: String,
      default() {
        return '';
      }
    },
    name: {
      type: String,
      default() {
        return 'default-checkbox-name';
      }
    },
    modelValue: {
      type: Boolean,
      default() {
        return null;
      }
    },
    // value: {
    //   type: [Boolean, null],
    //   default() {
    //     return null;
    //   }
    // },
    large: {
      type: Boolean,
      default() {
        return false;
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      isChecked: false
    };
  },
  computed: {
    hasErrors() {
      //   return this.errors.has(this.name);
      return this.errors !== null && this.errors[this.name] !== undefined;
    }
  },
  methods: {
    handleChange(event) {
      // this.isChecked = event.target.checked;
      this.$emit('update:modelValue', event.target.checked);
    }
  }
};
</script>
